module.exports = __webpack_public_path__ + "img/mark-pattern-white.03d0500.svg";